module.exports = __webpack_public_path__ + "public/img/u17.18338eb2.png";